export enum ListVariant {
    POPUP = "popup",
    PERSISTENT = "persistent"
}
